module.exports = __webpack_public_path__ + "img/kgz.d4512584.svg";